export const FONT_COLORS = [
  { id: 1, label: 'Red', hex: '#EF2726' },
  { id: 2, label: 'Orange', hex: '#F27224' },
  { id: 3, label: 'Light Orange', hex: '#F1A722' },
  { id: 4, label: 'Yellow', hex: '#F2E21B' },
  { id: 5, label: 'Green', hex: '#8AC141' },
  { id: 6, label: 'Turquoise', hex: '#1F8A70' },
  { id: 7, label: 'Light Blue', hex: '#8DD1FF' },
  { id: 8, label: 'Blue', hex: '#4EAFE5' },
  { id: 9, label: 'Dark Blue', hex: '#206B8C' },
  { id: 10, label: 'Deep Blue', hex: '#004358' },
  { id: 11, label: 'Gray', hex: '#919191' }
];

export const BACKGROUND_COLORS = [
  { id: 1, label: 'Red', hex: '#EF2726' },
  { id: 2, label: 'Orange', hex: '#F27224' },
  { id: 3, label: 'Light Orange', hex: '#F1A722' },
  { id: 4, label: 'Yellow', hex: '#F2E21B' },
  { id: 5, label: 'Green', hex: '#8AC141' },
  { id: 6, label: 'Turquoise', hex: '#1F8A70' },
  { id: 7, label: 'Light Blue', hex: '#8DD1FF' },
  { id: 8, label: 'Blue', hex: '#4EAFE5' },
  { id: 9, label: 'Dark Blue', hex: '#206B8C' },
  { id: 10, label: 'Deep Blue', hex: '#004358' },
  { id: 11, label: 'Gray', hex: '#919191' }
];


// WEBPACK FOOTER //
// ./src/constants/colorsList.js